import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';

import { DashboardConfigResponse } from './types';

type FilterValue = string | number | Array<string | number>;

type EmbedRequest = {
    group: string;
    dashboard?: number;
    [key: Exclude<string, 'group' | 'dashboard'>]: FilterValue | undefined;
};

// const EMBED_API = `${getDomainOrigin()}/api/mpos/partner/Xiaomi/user/report/dashboard/embed`;
const EMBED_API = (partner: string) => {
    // return `${getDomainOrigin()}/api/mpos/partner/${partner}/user/d6bb4f6e-a4fa-423c-8dec-9d4bb70f7cb7/report/dashboard/embed/internal`;
    return `${getDomainOrigin()}/api/mpos/partner/${partner}/user/report/dashboard/embed`;
};

// export const fetchDashboardEmbed = async (
//     partner: string,
//     payload: EmbedRequest
// ): Promise<DashboardConfigResponse> => {
//     const response = await axios.post(EMBED_API(partner), payload);

//     const configs: DashboardConfigResponse = response.data;
//     console.log(configs);

//     return configs;
// };

let abortController: AbortController | null = null;

export const fetchDashboardEmbed = async (
    partner: string,
    payload: EmbedRequest
): Promise<DashboardConfigResponse> => {
    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();

    const response = await axios.post(EMBED_API(partner), payload, {
        ...getAxiosConfig(),
        signal: abortController.signal,
    });

    return response.data;
};
